export function formatAmount(amount: number) {
  const intFormat = new Intl.NumberFormat('fr-FR')
  return intFormat.format(amount)
}

export function formatDateFrench(dateString: string | null | undefined): string {
  if (!dateString) return '-'
  const mois = [
    'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
  ]
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return '-'
  const jour = date.getDate().toString().padStart(2, '0')
  const moisNom = mois[date.getMonth()]
  const annee = date.getFullYear()
  return `${jour} ${moisNom} ${annee}`
}

export function formatDateShort(dateString: string | null | undefined): string {
  if (!dateString) return '-'
  const mois = [
    'Jan.', 'Fév.', 'Mars', 'Avr.', 'Mai', 'Juin',
    'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'
  ]
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return '-'
  const jour = date.getDate().toString().padStart(2, '0')
  const moisNom = mois[date.getMonth()]
  const annee = date.getFullYear()
  return `${jour} ${moisNom} ${annee}`
}

export function maskPhone(phone: string | null | undefined): string {
  if (!phone) return '-'
  if (phone.length <= 6) return phone
  const prefix = phone.substring(0, 7)
  const suffix = phone.substring(phone.length - 2)
  return `${prefix} ${'*'.repeat(phone.length - 9)} ${suffix}`
}

export function maskEmail(email: string | null | undefined): string {
  if (!email) return '-'
  const [name, domain] = email.split('@')
  if (!domain) return email
  const visible = name.substring(0, 3)
  return `${visible}${'*'.repeat(Math.max(name.length - 3, 3))}@${domain}`
}

export const AMOUNT_FORMAT_CONFIG = {
  masked: false,
  prefix: '',
  suffix: '',
  thousands: ' ',
  decimal: ',',
  precision: 2,
  disableNegative: false,
  disabled: false,
  min: null,
  max: null,
  allowBlank: false,
  minimumNumberOfCharacters: 0,
  shouldRound: true,
  focusOnRight: false
}

export const PERCENTAGE_FORMAT_CONFIG = {
  masked: false,
  prefix: '',
  suffix: '',
  thousands: ' ',
  decimal: ',',
  precision: 2,
  disableNegative: false,
  disabled: false,
  min: 0,
  max: 100,
  allowBlank: false,
  minimumNumberOfCharacters: 0,
  shouldRound: true,
  focusOnRight: false
}

